import {
    WorkflowStepDataContentPack,
    WorkflowWorkflowInfo,
} from '@calm/evexia-web-sdk';

export const FtueStoredStepName = 'CURRENT_FTUE_WORKFLOW_STEP';

export const StepStates = {
    IN_PROGRESS: 'step_in_progress',
    COMPLETED: 'step_completed',
    SKIPPED: 'step_skipped',
    DECLINED: 'step_declined',
};

export const WorkflowIds = {
    FTUE: 'workflow-user-registration-ftue',
    REGISTRATION: 'workflow-user-registration-ftue',
    ACCESS_CODE: 'workflow-user-registration-access-code',
    SSO_IN: 'workflow-user-registration-sso-in',
    MAGIC_LINK_SPONSOR: 'workflow-user-registration-magic-link-sponsor',
    MAGIC_LINK_FRIENDS_FAMILY:
        'workflow-user-registration-magic-link-friends-family',
};

export const FtueStepDefinitionIds = {
    ONBOARDING_VIDEO_1: 'pack-class-goals-and-topics',
    GOALS: 'step-checkin-entry-goal',
    TOPICS: 'step-checkin-entry-topic',
    ONBOARDING_VIDEO_2: 'pack-class-goals-and-topics-pt-2',
    CONDITIONS: 'step-checkin-conditions',
    ONBOARDING_VIDEO_3: 'pack-class-mental-health-screen',
    MENTAL_HEALTH_SCREENING: 'poll-mental-health',
    ONBOARDING_VIDEO_4: 'pack-class-mental-health-screen-pt-2',
    CARE_PLAN: 'step-end-workflow',
};

export function getWorkflowPackClass(workflow: WorkflowWorkflowInfo) {
    const data: WorkflowStepDataContentPack | undefined = workflow?.steps.find(
        (step) =>
            step.stepDefn.type === 'content_pack' && step.stepDefn.data.display
    )?.stepDefn.data as WorkflowStepDataContentPack;
    return data?.relatedId;
}

export function getWorkflowCurrentStep(
    workflow: WorkflowWorkflowInfo | undefined
) {
    return workflow?.steps.find(
        (step) => step?.stepInstance?.currentState === 'step_in_progress'
    );
}
